export default from './share-form';



// WEBPACK FOOTER //
// ./app/components/share-form/index.js